import React from "react";

const ICONS = {
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M16 3v4M8 3v4M3 10h18" />
    </>
  ),
  certificate: (
    <>
      <circle cx="12" cy="9" r="6" />
      <path d="m8.5 14-1 7 4.5-2 4.5 2-1-7M9.5 9l1.6 1.6L14.8 7" />
    </>
  ),
  chevron: <path d="m9 18 6-6-6-6" />,
  content: (
    <>
      <path d="M6 2h9l5 5v15H6z" />
      <path d="M14 2v6h6M9 13h6M9 17h6" />
    </>
  ),
  delete: (
    <>
      <path d="M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14" />
      <path d="M10 11v6M14 11v6" />
    </>
  ),
  deliverables: (
    <>
      <path d="M3 6h6l2 2h10v12H3z" />
      <path d="m9 14 2 2 4-4" />
    </>
  ),
  diagnostic: (
    <>
      <path d="M4 19V5M4 19h16" />
      <path d="m7 15 4-4 3 2 5-6" />
    </>
  ),
  final: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m8 12 2.5 2.5L16.5 9" />
    </>
  ),
  forum: (
    <>
      <path d="M4 4h16v12H8l-4 4z" />
      <path d="M8 9h8M8 12h5" />
    </>
  ),
  home: (
    <>
      <path d="m3 11 9-8 9 8" />
      <path d="M5 10v11h14V10M9 21v-7h6v7" />
    </>
  ),
  logout: (
    <>
      <path d="M10 4H5v16h5M14 8l4 4-4 4M18 12H9" />
    </>
  ),
  profile: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </>
  ),
  support: (
    <>
      <path d="M4 13v-2a8 8 0 0 1 16 0v2" />
      <path d="M4 13a2 2 0 0 1 2-2h1v6H6a2 2 0 0 1-2-2zM20 13a2 2 0 0 0-2-2h-1v6h1a2 2 0 0 0 2-2z" />
      <path d="M17 17c0 2-2 3-5 3" />
    </>
  ),
  survey: (
    <>
      <path d="M7 3h10v4H7zM5 5H3v17h18V5h-2" />
      <path d="m8 13 2 2 5-5M8 19h8" />
    </>
  ),
  tasks: (
    <>
      <path d="M7 4H5v18h14V4h-2M9 2h6v4H9z" />
      <path d="m8 12 2 2 4-4M8 18h7" />
    </>
  ),
  tutorials: (
    <>
      <path d="M4 4h7a3 3 0 0 1 3 3v14a3 3 0 0 0-3-3H4z" />
      <path d="M20 4h-3a3 3 0 0 0-3 3v14a3 3 0 0 1 3-3h3z" />
    </>
  ),
  video: (
    <>
      <rect x="3" y="6" width="13" height="12" rx="2" />
      <path d="m16 10 5-3v10l-5-3z" />
    </>
  ),
};

const NavigationIcon = ({ className = "", name, size = 24 }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    >
      {ICONS[name] || ICONS.content}
    </g>
  </svg>
);

export default NavigationIcon;
